import type { RouteRecordRaw } from "vue-router";

const PosFinishOrderView = () => import("@views/app/pos-finish-order/pos-finish-order-view.vue");
const PosFinishStep4View = () => import("@views/app/pos-finish-order/pos-finish-step-4-view.vue");
const PosFinishOrderEndView = () => import("@views/app/pos-finish-order/pos-finish-order-end-view.vue");

export const posFinishOrderRoutes: RouteRecordRaw[] = [
    {
        component: PosFinishOrderView,
        name: "PosFinishOrder_home",
        path: "pos-finish-order",
        children: [
            {
                component: PosFinishStep4View,
                name: "PosFinishOrderStep4",
                path: "step-4/:id",
                props: true,
                meta: {
                    stepId: "Step4",
                    buttons: [
                        {
                            name: "Next",
                            action: "signContract",
                            label: "SignContract",
                            visible: true
                        }
                    ],
                    navigation: {
                        end: "PosFinishOrderEnd"
                    }
                }
            },
            {
                component: PosFinishOrderEndView,
                name: "PosFinishOrderEnd",
                path: "end/:id",
                props: true,
                meta: { buttons: [], navigation: {} }
            },
            {
                name: "PosFinishContractRoot",
                path: ":id",
                redirect: {
                    name: "PosFinishOrderStep4"
                }
            }
        ]
    }
];
